import { Controller } from "stimulus";
import Splide from "@splidejs/splide";

export default class extends Controller {

  static get targets() {
    return [
    ];
  }

  initialize() {
    this.isWatchWidth = true;
    this.setupOptions();
    this.slider = new Splide(this.element, this.options).mount();

    if(this.isWatchWidth) {
      this.watchWidth();
      this.onWidthChange(this.element);
    }
  }

  setupOptions() {
    const config = JSON.parse(this.element.dataset.config);
    const styles = getComputedStyle(this.element);
    const gap = styles.getPropertyValue('--gap') ? styles.getPropertyValue('--gap') : '32px';
    const padding = styles.getPropertyValue('--slider-padding') ? styles.getPropertyValue('--slider-padding') : '0px';
    const count = this.getSlideCount();
    const speed = parseFloat(config.slideTransitionSpeedSeconds, 10) * 1000;

    this.options = {
      gap: gap,
      padding: padding,
      perPage: count,
      pagination: !config.isHidePagination,
      arrows: !config.isHideArrows,
      classes: {
        page: 'splide__pagination__page w-5 h-5 block rounded-full bg-palette-background [&:not(.is-active)]:ring-1 [&:not(.is-active)]:ring-palette-paragraph-300 [&:not(.is-active)]:ring-inset transition-all [&.is-active]:border-palette-accent [&.is-active]:border-4',
      },
      autoplay: config.isAutoplay,
      rewind: true,
      updateOnMove: true,
      speed: speed,
      interval: speed + parseFloat(config.slideAutoplayIntervalSeconds, 10) * 1000,
      pauseOnHover: config.isPauseAutoplayHover,
    };

    this.options = this.applySlideTypeOverrides(this.options, config);
  }

  applySlideTypeOverrides(options, config) {
    let overrides = {};
    switch (config.sliderType) {
      case 'slideshow':
        overrides = {
          type: 'slide',
        };
        break;
      case 'carousel':
        overrides = {
          type: 'loop',
          rewind: false,
        };
        break;
      case 'fade-single-slide':
        overrides = {
          type: 'fade',
          perPage: 1,
        };
        this.isWatchWidth = false;
        break;
    }
    return {...options, ...overrides};
  }

  watchWidth() {
    const observer = new ResizeObserver(entries => {
      for (let entry of entries) {
        this.onWidthChange(entry);
      }
    });
    observer.observe(this.element);
  }

  onWidthChange(element) {
    this.sliderWidth = Math.ceil(this.element.offsetWidth);
    const count = this.getSlideCount();
    const currentCount = this.slider.options.perPage;
    if(count !== currentCount) {
      this.slider.options = {
        perPage: count,
      }
    }
  }

  getSlideCount() {    
    const slideCount = getComputedStyle(this.element).getPropertyValue('--slide-count');
    return slideCount ? slideCount : 1;
  }
};